import { render, staticRenderFns } from "./QualificationsRegistryEditForm.vue?vue&type=template&id=16e3daf6"
import script from "./QualificationsRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./QualificationsRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports